import "../Management/TrainingProcess.css";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import "../Management/ContentManagement.css";
import { MdAddTask } from "react-icons/md";
import { VscTasklist } from "react-icons/vsc";
import nexticn from "../Components/Assets/svg/chevron-right-solid.svg";
import backicn from "../Components/Assets/svg/back-chevron-right-solid (1).svg";
import { LuNotepadText } from "react-icons/lu";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import x from "../Components/Assets/Management/x-task.png";
import fb from "../Components/Assets/Management/fb-task.png";
import li from "../Components/Assets/Management/linkedin-task.png";
import insta from "../Components/Assets/Management/instagram-task.png";

export function TrainingProcess() {
  const navigate = useNavigate();
  const [companyProfile, setCompanyProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [assignProcess, setAssignProcess] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showdocstatus, setShowdocstatus] = useState(true);
  const [buttonAction, setButtonAction] = useState(null);
  const scrollRef = useRef(null);
  const approvedScrollRef = useRef(null);
  const [topRowTitleSection, setTopRowTitleSection] = useState(true);
  const [showFirstHalf, setShowFirstHalf] = useState(true);
  const [showSecondHalf, setShowSecondHalf] = useState(true);
  const [showCurrentdocstatus, setShowCurrentdocstatus] = useState(false);
  const [showCompleteddocstatus, setShowCompleteddocstatus] = useState(false);
  const [launchedTaskWindow, setLaunchedWindow] = useState(false);
  const [docs, setDocs] = useState([]);
  const [approveddocs, setApproveddocs] = useState([]);
  const [launcheddocs, setLauncheddocs] = useState([]);
  const [selectedLauncheddocs, setSelectedLauncheddocs] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const [selectedApprovedDocViewer, setSelectedApprovedDocViewer] =
    useState(null);
  const [tempRowStatus, setTempRowStatus] = useState(false);
  const [tempYetRowStatus, setYetTempRowStatus] = useState(false);
  const [showLaunchedTaskDetail, setShowLaunchedTaskDetail] = useState(false);
  const [tempYetLaunchedRowStatus, setTempYetLaunchedRowStatus] =
    useState(false);
  const [submitStatus, setSubmitStatus] = useState("idle"); // idle | submitting | submitted

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/process/documents?companyProfileId=${companyProfile?._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          const notApproved = response.data.data.filter(
            (doc) => doc.DocViewer === false
          );
          setDocs(notApproved);
          setTempRowStatus(notApproved.length > 0);
          // setTempRowStatus(notApproved);                                                                                                                                                                                                                                                                                                                                                            .length > 0);

          // Only include docs with DocViewer: true
          const approved = response.data.data.filter(
            (doc) => doc.DocViewer === true
          );
          setApproveddocs(approved);
          setYetTempRowStatus(approved.length > 0);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    if (companyProfile?._id) {
      fetchDocuments();
    }
  }, [companyProfile]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/company/get-company-profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setCompanyProfile(response.data);
        } else {
          toast.error("Company profile not found", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
          navigate("/new-company");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response?.status === 404) {
          toast.error("Please create a company profile first", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
          navigate("/new-company");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (submitStatus === "submitted") {
      newAssign();
    }
  }, [submitStatus]);

  const [taskForm, setTaskForm] = useState({
    DocId: "",
    title: "",
    description: "",
    documentType: "",
    DocViewer: false, // Add this line
  });
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setTaskForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    let type = "";
    if (ext === "pdf") type = "pdf";
    else if (["ppt", "pptx"].includes(ext)) type = "pptx";
    else if (["xls", "xlsx"].includes(ext)) type = "excel";
    else if (["doc", "docx"].includes(ext)) type = "word";
    else if (["txt", "md", "html"].includes(ext)) type = "blog";

    setTaskForm((prev) => ({
      ...prev,
      documentType: type,
    }));
  };
  const taskHandleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("submitting");
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("You must be logged in to upload a document", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        navigate("/login");
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("companyProfileId", companyProfile._id);
      formData.append("DocId", taskForm.DocId || "1"); // set DocId as needed
      formData.append("title", taskForm.title);
      formData.append("description", taskForm.description);
      formData.append("documentType", taskForm.documentType); // e.g., 'pdf', 'pptx', etc.
      formData.append("DocViewer", taskForm.DocViewer);
      // Add the document file
      const documentInput = document.querySelector('input[name="document"]');
      if (documentInput && documentInput.files[0]) {
        formData.append("document", documentInput.files[0]);
      } else {
        toast.error("Please select a document to upload", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        setSubmitStatus("idle");
        return;
      }

      if (!taskForm.documentType) {
        toast.error("Unsupported file type. Please upload a PDF, Word, PPT, Excel, or Text file.", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        setSubmitStatus("idle");
        return;
      }

      // Send the request to the server
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/process/docupload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Document uploaded successfully!", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
        setSubmitStatus("submitted");
        setTimeout(() => setSubmitStatus("idle"), 1500);
        // Optionally reset form here
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Error uploading document", {
          className: "gradient-toast",
          bodyClassName: "gradient-toast-body",
          progressClassName: "gradient-toast-progress",
        });
      setSubmitStatus("idle");
    }
  };
  const newAssign = () => {
    if (assignProcess === true) {
      setAssignProcess(false);
      setShowFirstHalf(true);
    } else {
      setAssignProcess(true);
      setShowFirstHalf(false);
    }
  };
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -350,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 350,
        behavior: "smooth",
      });
    }
  };
  const approvedScrollLeft = () => {
    if (approvedScrollRef.current) {
      approvedScrollRef.current.scrollBy({
        left: -350,
        behavior: "smooth",
      });
    }
  };

  const approvedScrollRight = () => {
    if (approvedScrollRef.current) {
      approvedScrollRef.current.scrollBy({
        left: 350,
        behavior: "smooth",
      });
    }
  };

  if (loading || !companyProfile) {
    return (
      <div className="loader-container">
        <span className="loader"></span>
      </div>
    );
  }

  return (
    <div className="content-management-page">
      {topRowTitleSection && (
        <div className="process-task-title-and-new-task">
          <div className="process-task-title">Document📄</div>
          <div
            className={`new-task-button${
              showCurrentdocstatus ? " disabled" : ""
            }`}
            onClick={() => {
              if (!showCurrentdocstatus) {
                newAssign();
              }
            }}
            style={{
              pointerEvents: showCurrentdocstatus ? "none" : "auto",
              opacity: showCurrentdocstatus ? 0.5 : 1,
              cursor: showCurrentdocstatus ? "not-allowed" : "pointer",
            }}
          >
            + Uploade Document
          </div>
        </div>
      )}
      <div className="task-row">
        {/* First Half */}
        <div className="task-boxes">
          {assignProcess && (
            <div className="assign-new-task">
              <div className="assign-new-task-row">
                <div className="new-task-form-title">
                  Uploade Document
                  <MdAddTask style={{ marginLeft: "8px" }} />
                </div>
                <img
                  onClick={() => {
                    newAssign();
                  }}
                  width="48"
                  height="48"
                  src="https://img.icons8.com/fluency/48/delete-sign.png"
                  alt="delete-sign"
                  className="status-cross-symbol"
                />
              </div>

              <form className="new-task-form" onSubmit={taskHandleSubmit}>
                <div className="new-task-row">
                  <div className="new-task-row-input">
                    <label htmlFor="title">
                      Task Title:<span className="red-imp">*</span>
                    </label>
                    <input
                      type="text"
                      name="title"
                      className="new-task-title"
                      placeholder="e.g., Summer Sale Campaign"
                      value={taskForm.title}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="new-task-row-input imp">
                    <label htmlFor="document">
                      Upload file (PDF, Word, PPT, Excel, Text formats
                      only):<span className="red-imp">*</span>
                    </label>
                    <input
                      type="file"
                      name="document"
                      className="img-input"
                      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.jpg,.jpeg,.png"
                      required
                      onChange={handleDocumentChange}
                    />
                  </div>
                  <div className="new-task-row-input">
                    <label htmlFor="description">Description:</label>
                    <textarea
                      name="description"
                      className="new-task-des"
                      placeholder="e.g., Focus on young users, fun tone, eco messaging"
                      value={taskForm.description}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>

                  <div class="checkbox-wrapper-51">
                    <label htmlFor="DocViewer">
                      <input
                        type="checkbox"
                        name="DocViewer"
                        checked={taskForm.DocViewer}
                        onChange={handleInputChange}
                        id="cbx-51"
                      />
                      <label for="cbx-51" class="toggle">
                        <span>
                          <svg width="10px" height="10px" viewBox="0 0 10 10">
                            <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                          </svg>
                        </span>
                      </label>
                      <div className="check-train-space"></div>
                      Check If it is Training Document
                    </label>
                  </div>
                </div>

                <div className="new-task-row-submit">
                  <button
                    type="submit"
                    className="new-task-row-submit-btn"
                    disabled={
                      submitStatus === "submitting" ||
                      submitStatus === "submitted"
                    }
                  >
                    {submitStatus === "submitting"
                      ? "Submitting..."
                      : submitStatus === "submitted"
                      ? "Submitted"
                      : "Submit"}
                    <VscTasklist
                      style={{
                        marginLeft: "8px",
                        height: "30px",
                        width: "30px",
                      }}
                    />
                  </button>
                </div>
              </form>
            </div>
          )}

          {showFirstHalf && (
            <div className="task-arrows">
              <img
                src={backicn}
                alt=""
                className="assign-task-btn back"
                onClick={scrollLeft}
              />
              {tempRowStatus ? (
                <>
                  <div className="task-row-container" ref={scrollRef}>
                    {docs.map((doc) => (
                      <div className="box" key={doc._id}>
                        <div className="cart-task-box-wrapper">
                          <div
                            className="process-cart-task-box process-doc-bg"
                            onClick={() => {
                              setSelectedDoc(doc);
                              setShowCurrentdocstatus(true);
                              setShowFirstHalf(false);
                            }}
                          >
                            <div className="top-id-card">
                              <div className="name-task">Doc id:</div>
                              <div className="task-number">#{doc.DocId}</div>
                            </div>
                            <div className="process-bottom-title-card">
                              <div className="process-task-box-title">
                                {doc.title}
                              </div>
                              <button
                                className="process-cart-task-btn"
                                onClick={() => {
                                  setSelectedDoc(doc);
                                  setShowCurrentdocstatus(true);
                                  setShowFirstHalf(false);
                                }}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="temp-row-container tsk">
                  <div className="temp-title">
                    Click above to add Documents!
                  </div>
                  <div className="temp-img"> </div>
                </div>
              )}
              <img
                src={nexticn}
                alt=""
                className="assign-task-btn next"
                onClick={scrollRight}
              />
            </div>
          )}
          {showCurrentdocstatus && (
            <div className="doc-show-status-container">
              <div className="close-button-row">
                <img
                  onClick={() => {
                    setShowFirstHalf(true);
                    setShowCurrentdocstatus(false);
                  }}
                  width="48"
                  height="48"
                  src="https://img.icons8.com/fluency/48/delete-sign.png"
                  alt="delete-sign"
                  className="status-cross-symbol"
                />
              </div>
              <div className="status-top-floor">
                <div className="status-top-floor-row-1">
                  <div className="status-col-1">
                    <div className="status-row remove-padding">
                      <div className="status-task-id">
                        <div className="task-id for-gradient-font">Doc ID</div>
                        <div className="task-id-number">
                          #{selectedDoc?.DocId}
                        </div>
                      </div>

                      <div className="status-task-title">
                        <div className="task-title-status">Document Title</div>
                        <div className="task-title-name-status">
                          {selectedDoc?.title}
                        </div>
                      </div>

                      <div className="status-task-des">
                        <div className="task-title-status">Description</div>
                        <div className="task-title-name-status doc-description">
                          {selectedDoc?.description}
                        </div>
                      </div>
                      <div className="doc-view-btn">
                        <button className="process-cart-task-btn">
                          <a
                            href={selectedDoc.linkformatedocument}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download
                          </a>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="task-row">
        {/* Second Half */}
        <div className="approve-title"> Training Document 📖</div>
        {showSecondHalf && (
          <>
            <div className="task-approved-row">
              <div className="task-arrows">
                <img
                  src={backicn}
                  alt=""
                  className="assign-task-btn back"
                  onClick={approvedScrollLeft}
                />
                {tempYetRowStatus ? (
                  <div
                    className="task-approved-row-container"
                    ref={approvedScrollRef}
                  >
                    {approveddocs.map((doc) => (
                      <div className="box" key={doc._id}>
                        <div className="cart-task-box-wrapper">
                          <div
                            className="process-cart-task-box training-doc-bg"
                            onClick={() => {
                              setSelectedApprovedDocViewer(doc);
                              setShowCompleteddocstatus(true);
                              setShowSecondHalf(false);
                            }}
                          >
                            <div className="top-id-card">
                              <div className="name-task">Doc id:</div>
                              <div className="task-number">#{doc.DocId}</div>
                            </div>
                            <div className="process-bottom-title-card">
                              <div className="process-task-box-title">
                                {doc.title}
                              </div>
                              <button
                                className="process-cart-task-btn"
                                onClick={() => {
                                  setSelectedApprovedDocViewer(doc);
                                  setShowCompleteddocstatus(true);
                                  setShowSecondHalf(false);
                                }}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="temp-row-container yet">
                    <div className="yet-temp-img"> </div>
                    <div className="temp-title">
                      Click above to add Documents Check it!
                    </div>
                  </div>
                )}

                <img
                  src={nexticn}
                  alt=""
                  className="assign-task-btn next"
                  onClick={approvedScrollRight}
                />
              </div>
            </div>
          </>
        )}
        {showCompleteddocstatus && (
          <div className="doc-show-status-container">
            <div className=" close-button-row">
              <img
                onClick={() => {
                  setShowCompleteddocstatus(false);
                  setShowSecondHalf(true);
                }}
                width="48"
                height="48"
                src="https://img.icons8.com/fluency/48/delete-sign.png"
                alt="delete-sign"
                className="status-cross-symbol"
              />
            </div>
            <div className="status-top-floor">
              <div className="status-top-floor-row-1">
                <div className="status-col-1">
                  <div className="status-row remove-padding">
                    <div className="status-task-id">
                      <div className="task-id for-gradient-font">Doc ID</div>
                      <div className="task-id-number">
                        #{selectedApprovedDocViewer?.DocId}
                      </div>
                    </div>

                    <div className="status-task-title">
                      <div className="task-title-status">Document Title</div>
                      <div className="task-title-name-status">
                        {selectedApprovedDocViewer?.title}
                      </div>
                    </div>

                    <div className="status-task-des">
                      <div className="task-title-status">Description</div>
                      <div className="task-title-name-status doc-description">
                        {selectedApprovedDocViewer?.description}
                      </div>
                    </div>
                    <div className="doc-view-btn">
                      <button className="process-cart-task-btn">
                        <a
                          href={selectedApprovedDocViewer.linkformatedocument}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download{" "}
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
       <ToastContainer position="top-right" autoClose={500}   hideProgressBar={false}
          newestOnTop={true}
          transition={Zoom} />
    </div>
  );
}
